import { HandleTabs } from "../../DetalleImpuestos"
import Modelo303 from "../Modelo303/Modelo303"

export const Modelo390 = (props: HandleTabs) => {
  return (
    <Modelo303
      props={props}
      isModel390
    />
  )
}
